import React from "react";
type AppProps = {
  status: boolean;
  handleEnableDisableClick?: (data: any) => void;
  tableData: any;
};
const TableToggleSwitch = ({
  status,
  handleEnableDisableClick,
  tableData,
}: AppProps) => {
  return (
    <td style={{ maxWidth: "80px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
          gap: "3px",
        }}
      >
        <label className="switchs m-0">
          <input
            type="checkbox"
            checked={status}
            onChange={() => {
              handleEnableDisableClick &&  handleEnableDisableClick(tableData);
            }}
          />
          <span
            className="sliders rounds"
            style={{
              backgroundColor: !status ? "gray" : "",
            }}
          ></span>
        </label>
      </div>
    </td>
  );
};

export default TableToggleSwitch;
